var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgUserEdit = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Icon_user-edit",
    "data-name": "Icon / user-edit",
    xmlns: "http://www.w3.org/2000/svg",
    width: 17.2,
    height: 13.761,
    viewBox: "0 0 17.2 13.761",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon_user",
    "data-name": "Icon / user"
  }, /*#__PURE__*/React.createElement("path", {
    id: "eye-slash-regular",
    d: "M4.05,2.493A7.339,7.339,0,0,1,8.6.86a7.567,7.567,0,0,1,5.176,2.166,10.412,10.412,0,0,1,2.5,3.523.855.855,0,0,1,0,.661,10.656,10.656,0,0,1-2.147,3.182l2.827,2.214a.645.645,0,0,1-.8,1.016L.247,1.153a.645.645,0,1,1,.8-1.015ZM5.1,3.319l1.236.967a3.442,3.442,0,0,1,5.321,4.171L13.1,9.592A10.449,10.449,0,0,0,15.012,6.88,9.7,9.7,0,0,0,12.9,3.97,6.311,6.311,0,0,0,8.6,2.126,5.928,5.928,0,0,0,5.1,3.319Zm5.512,4.319a2.19,2.19,0,0,0,.137-.782A2.165,2.165,0,0,0,8.6,4.706c-.019,0-.035.024-.078.024a1.034,1.034,0,0,1,.078.406,1.74,1.74,0,0,1-.177.785Zm.253,3.5,1.126.887A7.065,7.065,0,0,1,8.6,12.9a7.562,7.562,0,0,1-5.176-2.166,10.944,10.944,0,0,1-2.5-3.523.859.859,0,0,1,0-.661A10.219,10.219,0,0,1,2.233,4.34l1.013.8A8.626,8.626,0,0,0,2.189,6.856,9.332,9.332,0,0,0,4.3,9.791,6.291,6.291,0,0,0,8.6,11.61a5.717,5.717,0,0,0,2.266-.47ZM5.16,6.856c0-.054,0-.129.008-.2L6.676,7.84a2.055,2.055,0,0,0,1.44,1.113l1.51,1.212a4.418,4.418,0,0,1-1.051.156,3.46,3.46,0,0,1-3.44-3.464Z",
    transform: "translate(0 0)",
    fill: "#1a1a1a"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgUserEdit);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/user-edit.410045f15b6450806fcee58fd8865f28.svg";